import type { I18nFn } from '#/i18n/types/I18nFn';

type Args = {
  i18n: I18nFn;
};

export function getEventApplySectionTitle({ i18n }: Args) {
  return i18n('How to Join');
}
